import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Core Web Vitals: log in development; forward to your analytics backend in production if needed.
reportWebVitals((metric) => {
	if (process.env.NODE_ENV === 'development') {
		// eslint-disable-next-line no-console
		console.debug('[web-vitals]', metric.name, Math.round(metric.value * 10) / 10, metric.id);
	}
});
